'use client'

import { motion } from 'framer-motion'
import { MoreVertical } from 'lucide-react'
import { usePageSave } from '../../contexts/PageSaveContext'

export default function TaxableStatus() {
  const { isPageSaved } = usePageSave()
  
  // Required pages for return preparation status calculation
  const requiredPages = [
    { key: 'profile', label: 'Profile' },
    { key: 'salary', label: 'Salary' },
    { key: 'filing-section', label: 'Filing Section' }
  ]
  
  // Calculate completion percentage
  const completedPages = requiredPages.filter(page => isPageSaved(page.key)).length
  const completionPercentage = Math.round((completedPages / requiredPages.length) * 100)
  
  // Calculate donut chart segments
  const segmentAngle = 360 / requiredPages.length
  const completedAngle = (completedPages / requiredPages.length) * 360
  
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 border w-[300px] h-[340px] m-auto" style={{borderRadius:'10px'}}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-gray-800">Return Preparation Status</h3>
        <button>
          <MoreVertical className="w-5 h-5 text-gray-400" />
        </button>
      </div>
      
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.5 }}
        className="relative aspect-square"
      >
        {/* Donut Chart */}
        <div className="absolute inset-0 flex items-center justify-center">
          <svg className="w-48 h-48 transform -rotate-90" viewBox="0 0 100 100">
            {/* Background circle - Gray for empty percentage */}
            <circle
              cx="50"
              cy="50"
              r="40"
              fill="none"
              stroke="#e5e7eb"
              strokeWidth="8"
            />
            {/* Progress circle - Green for completion percentage */}
            <circle
              cx="50"
              cy="50"
              r="40"
              fill="none"
              stroke="#10b981"
              strokeWidth="8"
              strokeLinecap="round"
              strokeDasharray={`${(completedAngle / 360) * 251.2} 251.2`}
              strokeDashoffset="0"
              className="transition-all duration-500 ease-in-out"
            />
          </svg>
        </div>
        
        {/* Center content */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center">
            <div className="text-3xl font-bold text-green-600">{completionPercentage}%</div>
            <div className="text-sm text-gray-500">Completed</div>
          </div>
        </div>
      </motion.div>
    </div>
  )
}

